
import Vue from 'vue';
import confirm from './components/confirm';
import DialogTip from './components/DialogTip';
let confirmConstructor = Vue.extend(confirm);
let DialogTipConstructor = Vue.extend(DialogTip);
const theConfirm = function (text) {
    return new Promise((res, rej) => { //promise封装，ok执行resolve，no执行rejectlet
        let confirmDom = text.tip ? new DialogTipConstructor({
            el: document.createElement('div')
        }) : new confirmConstructor({
            el: document.createElement('div')
        })
        // document.body.appendChild(confirmDom.$el);  //new一个对象，然后插入body里面
        const bdoConfirmPopup = document.getElementById('bdoConfirmPopup');
        if(bdoConfirmPopup) {
            document.getElementById('bdoConfirmPopup').innerHTML = '';
            document.getElementById('bdoConfirmPopup').appendChild(confirmDom.$el);
        } else {
            const newBdoConfirmPopup = document.createElement('div');
            newBdoConfirmPopup.setAttribute('id', 'bdoConfirmPopup');
            newBdoConfirmPopup.appendChild(confirmDom.$el);
            document.body.appendChild(newBdoConfirmPopup);
        }
        confirmDom.text = Object.assign({},confirmDom.text, text);   //为了使confirm的扩展性更强，这个采用对象的方式传入，所有的字段都可以根据需求自定义
        confirmDom.confirm = function () {
            confirmDom.isShow = false;
            rej("确认")
        }
        confirmDom.cancel = function () {
            confirmDom.isShow = false;
            res("取消")
        }
    })
}
export default theConfirm;